// extracted by mini-css-extract-plugin
export default {"root":"ProductPhoto_root__AqAZm","picture":"ProductPhoto_picture__TGUku","placeHolderShimmer":"ProductPhoto_placeHolderShimmer__5N1nd"};